import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { AdFoxContainer } from '../AdFox';
import { useSelector } from 'react-redux';
import { selectUserIsAgent } from '../../../selectors/user';
import { selectAdfoxInfo } from '../../../selectors/newbuilding';

export const StretchBannerContainer = () => {
  const isAgent = useSelector(selectUserIsAgent);
  const adfoxInfo = useSelector(selectAdfoxInfo);
  const agentMark = isAgent ? 'agent' : 'not_agent';
  const params = {
    ...adfoxInfo,
    p1: 'bvknz',
    p2: 'y',
    puid10: agentMark,
  };

  React.useEffect(() => {
    const stretchBannerDomElement = document.getElementById('stretch-banner');

    if (stretchBannerDomElement) {
      const root = ReactDOM.createRoot(stretchBannerDomElement);
      root.render(
        <AdFoxContainer ownerId={202100} disableYan={isAgent} params={params} minHeight="200px" width="100%" />,
      );
    }
  }, []);

  return null;
};
